{
  "id": "campaign-094",
  "name": "Unkempt Rest",
  "seed": "campaign:94",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "...,L__L...,",
    "..,,,__,...,",
    ",i,i,__,i.i,",
    ",,,,i__i,,,,",
    ",,,,,__,,%,,",
    ",x,,,__,%%%,",
    ",,,,,__,,%,,",
    ",,,,,__~,,,,",
    "____________",
    "x,,h,__~h...",
    ",,,,,__,,...",
    ",i,i,__.i.i.",
    ",,,,,__...,,",
    ",,,,x__..%,,",
    ",,,,,__,%%%,",
    ",,,,,__,~%~,",
    "..,,,,,,,,,,",
    "S...,,,,,,,X"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 11,
      "y": 10
    },
    {
      "kind": "squirrel",
      "x": 8,
      "y": 1
    },
    {
      "kind": "rabbit",
      "x": 7,
      "y": 12
    },
    {
      "kind": "squirrel",
      "x": 1,
      "y": 1
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 1,
      "y": 14
    },
    {
      "kind": "gas",
      "x": 10,
      "y": 3
    },
    {
      "kind": "gas",
      "x": 2,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 17
    },
    {
      "kind": "repair",
      "x": 3,
      "y": 1
    }
  ],
  "falls": [
    {
      "x": 11,
      "y": 17,
      "dir": "W",
      "at": 15,
      "length": 3
    }
  ],
  "generatorVersion": 3,
  "level": 94,
  "biome": "cemetery",
  "par": {
    "reel": 15197,
    "push": 9121,
    "selfPropelled": 8322,
    "tractor": 4640,
    "zeroTurn": 5567,
    "fairway": 3796
  },
  "routeTries": {
    "par": {
      "reel": 15,
      "push": 15,
      "selfPropelled": 5,
      "tractor": 13,
      "zeroTurn": 13,
      "fairway": 5
    }
  }
}
